import tokens from '@kluein/design-tokens';
import { Box, Text, CheckBox } from '@kluein/klue-ui';
import { useTranslation } from 'react-i18next';

import { CountText } from 'components/common/count-text';

import type { BattlecardsType } from 'api/api.types';

type CardBattlecardItemProps = {
  battlecard: Partial<BattlecardsType> & { id: number };
  isDefault?: boolean;
  checked: boolean;
  onToggleChecked: (battlecardId: number) => void;
  cardCounts: number;
};

const CardBattlecardItem = ({
  battlecard,
  isDefault,
  checked,
  onToggleChecked,
  cardCounts,
}: CardBattlecardItemProps) => {
  const { id, title } = battlecard;
  const { t } = useTranslation();
  return (
    <Box
      margin={{ bottom: 'small' }}
      flex={false}
      id={`card-battlecard-item-${battlecard.id}`}
    >
      {isDefault ? (
        <Text
          size="small"
          margin={{ left: 'xxlarge' }}
          color={tokens.color.primitives.gray[425]}
        >
          {t('Battlecard:default')}
        </Text>
      ) : null}
      <Box direction="row" align="center" justify="between" gap="small">
        <Box direction="row" align="center" justify="between" gap="small">
          <CheckBox checked={checked} onChange={() => onToggleChecked(id)} />
          <Text
            onClick={() => onToggleChecked(id)}
            fontWeight={isDefault ? 'semibold' : 'normal'}
            size="large"
            color={tokens.color.neutral.black.main}
            style={{ cursor: 'pointer' }}
          >
            {title}
          </Text>
        </Box>
        <CountText>
          <Text>{cardCounts}</Text>
        </CountText>
      </Box>
    </Box>
  );
};

export default CardBattlecardItem;
